export default {
      id: "quote-usage",
      viewBox: "0 0 133.43 106.25",
      url: __webpack_public_path__ + "img/icons.fcdc0825.svg#quote",
      toString: function () {
        return this.url;
      }
    }